import { enableProdMode, Injector } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./js/src/app.module";
import { Auth } from "./js/src/infrastructure/auth";
import { environment } from "./environments/environment";
import { ContentControlStudioModule } from "./js/src/components/content-control/studio/content-control-studio/content-control-studio.module";
if (environment.production) {
  enableProdMode();
}

const injector = Injector.create([{ provide: Auth, deps: [] }]);
const auth = injector.get(Auth) as Auth;

if (!auth.loggedIn()) {
  window.location.href = "/login";
} else {
  if (window.location.href.includes("content-control/studio/")) {
    platformBrowserDynamic()
      .bootstrapModule(ContentControlStudioModule)
      .catch((err) => console.error(err));
  } else {
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  }
}
